module.exports = __webpack_public_path__ + "img/women-box01.1e47f11a.png";